'use client';

import { ErrorLayout } from "@/layouts/error-layout";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
export default function Error({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <ErrorLayout title={'Page Not Found'} errorCode={500} data-sentry-element="ErrorLayout" data-sentry-component="Error" data-sentry-source-file="error.tsx" />;
}